import { DOC_TYPE_LABELS, DOC_TYPES, type DocType } from '../utils/docTypes'

export interface DocTypeChipFilterProps {
  value: DocType[]
  onChange: (value: DocType[]) => void
  /** Restrict chips to these types. Defaults to the full controlled vocabulary. */
  types?: readonly DocType[]
  disabled?: boolean
  /** Show an "All" chip first; active when value is empty. */
  showAll?: boolean
}

export default function DocTypeChipFilter({
  value,
  onChange,
  types = DOC_TYPES,
  disabled = false,
  showAll = false,
}: DocTypeChipFilterProps) {
  const allSelected = value.length === 0

  const toggle = (type: DocType) => {
    onChange(value.includes(type) ? value.filter((t) => t !== type) : [...value, type])
  }

  const chipClass = (active: boolean) =>
    `px-2.5 py-0.5 text-xs font-medium rounded-full border transition-colors disabled:opacity-50 ${
      active
        ? 'bg-emerald-500/20 border-emerald-500 text-emerald-300'
        : 'bg-harbor-surface-raised border-harbor-border text-harbor-text-secondary hover:border-gray-500'
    }`

  return (
    <div className="flex flex-wrap gap-1.5">
      {showAll && (
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange([])}
          className={chipClass(allSelected)}
        >
          All
        </button>
      )}
      {types.map((type) => (
        <button
          key={type}
          type="button"
          disabled={disabled}
          onClick={() => toggle(type)}
          className={chipClass(value.includes(type))}
        >
          {DOC_TYPE_LABELS[type] ?? type}
        </button>
      ))}
    </div>
  )
}
